import { render, staticRenderFns } from "./SiteNav.vue?vue&type=template&id=2c019190&scoped=true"
import script from "./SiteNav.vue?vue&type=script&lang=js"
export * from "./SiteNav.vue?vue&type=script&lang=js"
import style0 from "./SiteNav.vue?vue&type=style&index=0&id=2c019190&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c019190",
  null
  
)

export default component.exports